export class QDiagnosticOut {
  constructor() {
    this.fCurOrg = null;
    this.fCurUser = null;
    this.fDataTypeDict = null;
    this.fFilename = null;
    this.fRowList = null;
    this.fWSMgr = null;
  }

  Init(curOrg, curUser, filename, wsMgr) {
    this.fWSMgr = wsMgr;
    this.fCurOrg = curOrg;
    this.fCurUser = curUser;
    this.fFilename = filename;
    this.fRowList = [];
  }

  ExcelJSONResult(success, r) {
    if (success) {
      var filename = r;
      var w = this.fWSMgr;
      w.DownloadPub(filename);
    }
  }

  AddDataRow(addRow) {
    var n = addRow.length;
    var dataObj = this.fHeaders;
    var aRow = {};
    for (var i = 0; i < n; i++) {
      var v = addRow[i];
      if (v == null) v = "";
      else v = v.toString();
      aRow[dataObj[i]] = v;
    }
    this.fRowList.push(aRow);
  }

  SetJSON(dict) {
    this.fDataTypeDict = dict;
  }

  GetJSON() {
    return this.fDataTypeDict;
  }
}
